<template>
    <div>
    <div class="container pr-3 pl-3 margin-5" style="background-color: white;padding-bottom: 3rem">
        <div class=" pr-3 pl-3" style="margin-top: 5%">
            <div class=" col-12 logo-side text-center">
                <img class="mt-md-3 logo-size"
                     src="../assets/logo-login.png">
                &nbsp;
                <span class="text-head">กองป้องกันการบาดเจ็บ กรมควบคุมโรค</span>
            </div>
        </div>
        <div class="mt-3 offset-sm-2 col-sm-8 offset-1 col-10">
            <div class="text-content text-center">
                <div class="pl-5 pr-5 ">
                        เลขที่ 88/21 อาคาร 11 ชั้น 6 ตึกกรมควบคุมโรค
                </div>
              <div class="pl-5 pr-5 ">
                ถนนติวานนท์ ตำบลตลาดขวัญ อำเภอเมือง จังหวัดนนทบุรี 11000
              </div>
                <div class="row">
                    <div class="col-12">
                        <div>
                          โทรศัพท์ 0 2590 3953, โทรสาร 0 2590 3893
                        </div>
                    </div>
                </div>

            </div>

          <div class="form-group text-req">
            <label >เลือกระดับผู้ใช้</label>
            <multiselect
              @input="clearSelect()"
              v-model="user_type"
              :options="optionUserLevel"
              label="name"
              select-label=""
              selectedLabel=""
              deselect-label=""
              placeholder="ระดับผู้ใช้"
              track-by="name">
            </multiselect>
          </div>

          <template v-if="login_form.user_type_id == 1">
            <div class="form-group text-req">
              <label >ระดับเขต</label>
              <multiselect
                v-model="login_form.area_id"
                :options="optionArea"
                label="name"
                select-label=""
                selectedLabel=""
                deselect-label=""
                placeholder="ระดับเขต"
                track-by="name">
              </multiselect>
            </div>
          </template>

          <template v-if="login_form.user_type_id == 2">
            <div class="form-group text-req">
              <label >จังหวัด</label>
              <multiselect
                v-model="login_form.province_id"
                :options="optionProvince"
                label="name"
                select-label=""
                selectedLabel=""
                deselect-label=""
                placeholder="เลือกจังหวัด"
                track-by="name">
              </multiselect>
            </div>
          </template>

          <template v-if="login_form.user_type_id == 3">
            <div class="form-group text-req">
              <div class="row">
                <div class="col-md-6 col-12">
                  <label >จังหวัด</label>
                  <multiselect
                    v-model="login_form.province_id"
                    @input="getDistricts(login_form.province_id)"
                    :options="optionProvince"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="เลือกจังหวัด"
                    track-by="name">
                  </multiselect>
                </div>
                <div class="col-md-6 col-12">
                  <label >อำเภอ</label>
                  <multiselect
                    v-model="login_form.district_id"
                    :options="optionDistrict"
                    label="name"
                    select-label=""
                    selectedLabel=""
                    deselect-label=""
                    placeholder="เลือกอำเภอ"
                    track-by="name"
                    :allow-empty="false" >
                  </multiselect>
                </div>
              </div>
            </div>
          </template>

          <template v-if="login_form.user_type_id == 4">
            <div class="form-group text-req">
              <label >จังหวัด</label>
              <multiselect
                v-model="login_form.province_id"
                @input="getHospitals(login_form.province_id)"
                :options="optionProvince"
                label="name"
                select-label=""
                selectedLabel=""
                deselect-label=""
                placeholder="เลือกจังหวัด"
                track-by="name">
              </multiselect>
            </div>
          </template>

<!--          <template v-if="login_form.user_type_id == 4 && login_form.province_id !=''">-->
<!--            <div class="form-group text-req">-->
<!--              <label >โรงพยาบาล</label>-->
<!--              <multiselect-->
<!--                v-model="login_form.hospital"-->
<!--                :options="optionHospital"-->
<!--                label="name"-->
<!--                select-label=""-->
<!--                selectedLabel=""-->
<!--                deselect-label=""-->
<!--                placeholder="เลือกโรงพยาบาล"-->
<!--                track-by="id">-->
<!--              </multiselect>-->
<!--            </div>-->
<!--          </template>-->

          <div class="form-group text-req">
            <label >ชื่อ - นามสกุล</label>
            <div class="col-12">
            <b-form-input class="text-req"
              v-model="login_form.fullname"
              type="text"
              placeholder="ชื่อ - นามสกุล"/>
            </div>
          </div>

          <div class="form-group text-req">
            <label >ตำแหน่ง</label>
            <div class="col-12">
            <b-form-input class="text-req"
              v-model="login_form.position"
              type="text"
              placeholder="ตำแหน่ง"/>
            </div>
          </div>

          <div class="form-group text-req">
            <label >หน่วยงาน</label>
            <div class="col-12">
            <b-form-input class="text-req"
              v-model="login_form.organize"
              type="text"
              placeholder="หน่วยงาน"/>
            </div>
          </div>

          <div class="form-group text-req">
            <label >เบอร์โทรศัพท์</label>
            <div class="col-12">
            <b-form-input class="text-req"
              v-model="login_form.tel"
              type="text"
              placeholder="เบอร์โทรศัพท์"/>
            </div>
          </div>

          <div class="form-group text-req">
            <label >อีเมลสำหรับติดต่อกลับ</label>
            <div class="col-12">
            <b-form-input class="text-req"
              v-model="login_form.email"
              type="text"
              placeholder="อีเมลสำหรับติดต่อกลับ"/>
            </div>
          </div>

          <div class="form-group text-req">
            <label >รายละเอียด</label>
            <div class="col-12">
            <b-form-textarea class="text-req"
              v-model="login_form.msg"
              placeholder="รายละเอียด"/>
            </div>
          </div>

          <div class="text-center mt-4">
                <b-button @click="login" variant="dark"
                          class=" btn-form mr-3" style="background: whitesmoke; border: 2px solid #006738;color:#006738;">
                <span >
                    กลับสู่หน้าหลัก
                </span>
                </b-button>
            <b-button @click="send" variant="dark"
                      class=" btn-form pl-5 pr-5" style="border: 2px solid #006738;">
                <span >
                    ส่งคำขอ
                </span>
            </b-button>
            </div>


        </div>
        </div>

<!--      <pre>{{login_form}}</pre>-->
      <footer-view></footer-view>
        <!--        <pre class="alert-danger">{{form}}</pre>-->
        <!--        <pre v-if="form.province" class="alert-danger">{{form.province.code}}</pre>-->
    </div>
</template>

<script>
    import FooterView from "./FooterView";
    import Multiselect from "vue-multiselect";
    import {mapState} from "vuex";

    export default {
        name: "ContactView.vue",
      components: {
        FooterView,
        Multiselect
      },
      created(){
        this.$store.dispatch("Common/setProvinces");
        this.$store.dispatch("Common/setHospital");
      },
      computed: {
        ...mapState({
          form : state=>{
            return state.Auth.form;
          },
          optionProvince : state=>{
            return state.Common.provinces;
          },
          optionDistrict : state=>{
            return state.Common.districts;
          },
          optionHospital : state=>{
            return state.Common.hospitals;
          },
          user_login : state=>{
            return state.Auth.user_login
          }
        })
      },
      data() {
        return {
          login_form:{
            user_type_id:"",
            area_id:"",
            province_id:"",
            district_id:"",
            fullname : '',
            position : '',
            organize : '',
            tel : '',
            email : '',
            msg : '',
            // hospital:"",

          },
          email : '',
          msg : '',
          user_type : '',
          optionArea : [
            {
              'id': 1,
              'name' : 'เขต 1'
            },
            {
              'id': 2,
              'name' : 'เขต 2'
            },
            {
              'id': 3,
              'name' : 'เขต 3'
            },
            {
              'id': 4,
              'name' : 'เขต 4'
            },
            {
              'id': 5,
              'name' : 'เขต 5'
            },
            {
              'id': 6,
              'name' : 'เขต 6'
            },
            {
              'id': 7,
              'name' : 'เขต 7'
            },
            {
              'id': 8,
              'name' : 'เขต 8'
            },
            {
              'id': 9,
              'name' : 'เขต 9'
            },
            {
              'id': 10,
              'name' : 'เขต 10'
            },
            {
              'id': 11,
              'name' : 'เขต 11'
            },
            {
              'id': 12,
              'name' : 'เขต 12'
            },
            {
              'id': 13,
              'name' : 'สปคม'
            }
          ],
          optionUserLevel : [
            {
              'id': 0,
              'name' : 'ส่วนกลาง'
            },
            {
              'id': 1,
              'name' : 'ระดับเขต'
            },
            {
              'id': 2,
              'name' : 'ระดับจังหวัด'
            },
            {
              'id': 3,
              'name' : 'ระดับอำเภอ'
            },
            // {
            //   'id': 4,
            //   'name' : 'ระดับโรงพยาบาล'
            // }
          ],
        };
      },
      methods:{
        login(){
          this.$router.push({
            name:"LoginView"
          });
        },
        getDistricts(province){
          if(province){
            this.login_form.district_id = "";
            this.$store.dispatch('Common/setDistrict',province.code);
          }
        },
        getHospitals(province){
          if(province){
            this.login_form.hospital = "";
            this.$store.dispatch('Common/setHospital',province.code);
          }
        },
        showErrorFill(message){
          const Toast = this.$swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            type: 'error',
            title: message
          })
        },
        clearSelect(){
          console.log(this.login_form.user_type)
          this.login_form.user_type_id = this.user_type.id
          if (this.login_form.user_type_id == 0 ){
            this.login_form.area_id = "";
            this.login_form.province_id = "";
            this.login_form.district_id = "";
            this.login_form.hospital = "";
          } else if (this.login_form.user_type_id == 1){
            this.login_form.area_id = "";
            this.login_form.province_id = "";
            this.login_form.district_id = "";
            this.login_form.hospital = "";
          }else if (this.login_form.user_type_id == 2){
            this.login_form.area_id = "";
            this.login_form.province_id = "";
            this.login_form.district_id = "";
            this.login_form.hospital = "";
          }else if (this.login_form.user_type_id == 3) {
            this.login_form.area_id = "";
            this.login_form.province_id = "";
            this.login_form.district_id = "";
            this.login_form.hospital = "";
          }else {
            this.login_form.area_id = "";
            this.login_form.province_id = "";
            this.login_form.district_id = "";
            this.login_form.hospital = "";
          }
        },
        send(){
          if(!this.user_type){
            this.showErrorFill('กรุณาเลือกระดับผู้ใช้');
          }
          else if(this.login_form.user_type_id == 1 && this.login_form.area_id ==''){
            this.showErrorFill('กรุณาเลือกเขต');
          }
          else if(this.login_form.user_type_id == 2 && this.login_form.province_id =='' ) {
            this.showErrorFill('กรุณาเลือกจังหวัด');
          }
          else if(this.login_form.user_type_id == 3 && this.login_form.province_id == '') {
            this.showErrorFill('กรุณาเลือกจังหวัด');
          }
          else if(this.login_form.user_type_id == 3 && this.login_form.province_id != '' && this.login_form.district_id == '') {
            this.showErrorFill('กรุณาเลือกอำเภอ');
          }
          else if(this.login_form.user_type_id == 4 && this.login_form.hospital == '' ) {
            this.showErrorFill('กรุณาเลือกโรงพยาบาล');
          }
          else if(this.login_form.user_type_id == 4 && this.login_form.hospital != '' && this.login_form.province_id == '' ) {
            this.showErrorFill('กรุณาเลือกจังหวัด');
          }
          else if(!this.login_form.email){
            this.showErrorFill('กรุณากรอกอีเมล');
          }
          else if(!this.login_form.msg){
            this.showErrorFill('กรุณากรอกรายละเอียด');
          }
          else{
            let data = {
              area_id: this.login_form.area_id.id,
              user_type_id: this.login_form.user_type_id,
              email: this.login_form.email,
              province_id: this.login_form.province_id.code,
              district_id: this.login_form.district_id.id,
              hospital_code: this.login_form.hospital.code_5,
              msg: this.login_form.msg,
              full_name: this.login_form.fullname,
              position: this.login_form.position,
              organize: this.login_form.organize,
              tel: this.login_form.tel,
            };
            console.log(data)
            this.$store.dispatch("Auth/contact",data).then((res)=>{
              console.log(res);
              this.$swal.fire({
                showConfirmButton: true,
                type: 'success',
                title: 'ส่งคำขอสำเร็จ',
                text: 'กรุณารอการตอบกลับจากผู้ดูแลระบบ'
              })
              this.login_form.area_id = "";
              this.login_form.province_id = "";
              this.login_form.district_id = "";
              this.login_form.hospital = "";
              this.login_form.email = "";
              this.login_form.msg = "";
            }).catch(err => {
              console.log(err.response);
              let res = err.response;
              this.showErrorFill(res.data.message);
            })

          }
        },
      }
    }
</script>

<style scoped>
    .logo-size{
        height: 100px;
    }
    .text-head{
        font-size: 35px;
        font-weight: 700;
        color: #006738;
    }

    .text-content{
        font-size: 22px;
        font-weight: 700;
        color: #006738;
    }

    .text-req{
      font-size: 22px;
      font-weight: 700;
    }

    .btn-form{
        background-color: #006738;
        color: white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        border: 0;
        font-size: 20px;
        font-weight: 700;
        letter-spacing: 2px;
        text-align: center;
    }

    @media only screen and (max-width: 767px) {
        .logo-size{
            height: 60px;
        }
        .text-head{
            font-size: 20px;

        }
    }

    @media only screen and (max-width: 499px) {
        .logo-size{
            height: 50px;
        }
        .text-head{
            font-size: 18px;
        }
        .btn-form{
            font-size: 16px;
        }
        .text-content{
            font-size: 20px;
        }
    }

</style>
